<template>
  <manage-ticket
    :application="DE_TICKET_APP_PARENT"
    :modules="modules"
    :on-download="onDownloadHandler"
    :read-only="readOnly"
    :reference-number-types="referenceNumberTypes"
    :save-ticket="saveUserCase"
    :ticket-data="ticketData"
    :user="fullProfile"
    :validate-reference-number="validateReferenceNumber"
    @update-references="fetchReferenceNumberTypes"
    :studentsList="studentsList"
  />
</template>

<script>
import { ManageTicket } from 'support-tickets';
import {
  getUserCaseById,
  getUserCaseReferenceNumberTypes,
  saveUserCase as _saveUserCase,
  downloadDocument,
  getPreviousContactInformation,
  validateReferenceNumber as _validateReferenceNumber,
  getUserCaseModules as _getUserCaseModules,
} from '@/services/api/helpdesk.js';
import { name as userModuleName } from '@/modules/user/store';
import { mapGetters } from 'vuex';
import { serialize as objectToFormData } from 'object-to-formdata';
import documentService from '@/services/documents';
import { ParentApi } from '@/api/parent.api';

const DE_TICKET_APP_PARENT = 5;

const parentApi = new ParentApi();

const initialModel = () => ({
  itemId: null,
  description: null,
  documents: [
    {
      tempId: 1,
      id: null,
      data: null,
      name: null,
    },
  ],
  module: null,
  screen: null,
  referenceNumberTypes: [],
  email: null,
  telephone1: null,
  telephone2: null,
  statusId: null,
  workflowId: null,
  userContactInformation: {},
  modules: [],
});

export default {
  name: 'CreateTicket',
  components: { ManageTicket },
  data() {
    return {
      DE_TICKET_APP_PARENT,
      ticketData: initialModel(),
      readOnly: false,
      referenceNumberTypes: [],
      modules: [],
      studentsList: [],
    };
  },
  computed: {
    ...mapGetters(userModuleName, ['fullProfile']),
    studentSieList() {
      return [];
    },
  },
  async mounted() {
    const { id } = this.$route.params;
    await this.fetchReferenceNumberTypes();
    if (id) {
      const { data } = await getUserCaseById(id);
      this.ticketData = {
        ...data,
        documents: data.documents ?? [],
      };
      this.readOnly = true;
    } else {
      const contactInfo = await this.getPreviousContactInfo();
      this.ticketData.userContactInformation = contactInfo;
    }

    const { data: modules } = await _getUserCaseModules();
    this.modules = modules;

    const data = await parentApi.getChildren();
    if (data) {
      this.studentsList = data
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((c) => {
          return {
            id: c.studentSieId,
            name: `${c.name} - ${c.studentSieId}`,
          };
        });
    }
  },
  methods: {
    async fetchReferenceNumberTypes(params) {
      const { data } = await getUserCaseReferenceNumberTypes(params);
      this.referenceNumberTypes = [...data];
    },
    saveUserCase(data) {
      const formData = objectToFormData(data, {
        indices: true,
        nullsAsUndefineds: true,
      });
      return _saveUserCase(formData);
    },
    validateReferenceNumber(reference, referenceType) {
      return _validateReferenceNumber(reference, referenceType);
    },
    async onDownloadHandler(fileId) {
      if (fileId) {
        await downloadDocument(fileId);
      } else {
        let file = {
          filename: document.filename,
          content: document.file,
          contentType: 'application/pdf',
        };
        documentService.downloadFile(file);
      }
    },
    async getPreviousContactInfo() {
      const { data } = await getPreviousContactInformation();
      return data;
    },
  },
};
</script>
